import {
    Typography,
    IconButton,
    AppBar,
    Toolbar,
    Button,
    Fab,
    Tooltip
} from '@mui/material';
import { getCurrentUser } from '../services/userService';
import { useState } from 'react';
import { UserRole } from '../types/user';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import MyAccount from './MyAccount';
import CoatOfArms from '../../src/assets/Coatofarms.png';

interface TopBarProps {
    onLogout: () => void;
}

const TopBar = ({ onLogout }: TopBarProps): React.JSX.Element => {
    const [currentUser] = useState(getCurrentUser());
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const [myAccountOpen, setMyAccountOpen] = useState(false);

    // Dashboard is the home page - no back button needed there
    const showBack = currentPath !== '/dashboard';

    return (
        <>
            <AppBar position="static" color="transparent" elevation={0}>
                <Toolbar>
                    {showBack && (
                        <Tooltip title="Go back">
                            <IconButton
                                onClick={() => navigate(-1)}
                                color="primary"
                                aria-label="go back"
                                sx={{ mr: 1 }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Typography variant="h5" component="h1" sx={{ flexGrow: 1, fontWeight: 600 }}>
                        <Link to="/dashboard" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                            <img src={CoatOfArms} alt="Ministry of Health" height={40} />&nbsp;
                            <span>CQI Dashboard</span>
                        </Link>
                    </Typography>
                    
                    {/* Show View Detailed Dashboard button for subcounty, county, and national users */}
                    {(currentUser?.role === UserRole.SUBCOUNTY_USER || 
                      currentUser?.role === UserRole.COUNTY_USER || 
                      currentUser?.role === UserRole.NATIONAL_USER || 
                      currentUser?.role === UserRole.CQI_MANAGER) && (
                        <Button
                            variant={currentPath === '/analytics' ? 'contained' : 'outlined'}
                            color="primary"
                            onClick={() => navigate('/analytics')}
                            sx={{ mr: 2 }}
                        >
                            View Detailed Dashboard
                        </Button>
                    )}
                    
                    
                    <IconButton
                        onClick={() => setMyAccountOpen(true)}
                        color="primary"
                        title="My Account"
                    >
                        <AccountCircleIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Floating back button at the bottom of the page for easy navigation */}
            {showBack && (
                <Tooltip title="Go back">
                    <Fab
                        color="primary"
                        size="medium"
                        onClick={() => navigate(-1)}
                        aria-label="go back"
                        sx={{ position: 'fixed', bottom: 24, left: 24, zIndex: 1200 }}
                    >
                        <ArrowBackIcon />
                    </Fab>
                </Tooltip>
            )}

            {/* My Account dialog */}
            <MyAccount
                open={myAccountOpen}
                onClose={() => setMyAccountOpen(false)}
                user={currentUser}
                onLogout={onLogout}
            />
        </>
    );
};

export default TopBar;